// This is the one allowed use of fetch that allows us to not use it elsewhere
/* eslint-disable no-restricted-globals */

import {parseCsrfTokenFromPage} from './parseCsrfTokenFromPage';

export type ClientFetch = typeof fetch;

export function createClientFetch(csrfToken?: string): ClientFetch {
  return (input, init?) => {
    // Construct an augmented headers object that uses all provided headers
    const augmentedHeaders: Record<string, unknown> = {
      ...((init && init.headers) || {}),
      'X-Requested-With': 'fetch',
    };

    if (csrfToken) {
      augmentedHeaders['x-stripe-csrf-token'] = csrfToken;
    }

    const augmentedInit = {
      credentials: 'same-origin',
      ...(init || {}),
      headers: augmentedHeaders as HeadersInit,
    } as const;

    return fetch(input, augmentedInit);
  };
}

let _defaultClientFetch: ClientFetch | null = null;

export function defaultClientFetch() {
  if (_defaultClientFetch) {
    return _defaultClientFetch;
  }
  _defaultClientFetch = createClientFetch(parseCsrfTokenFromPage());
  return _defaultClientFetch;
}
